export const getLineItemPixelIds = lineItem => {
  return lineItem.conversion_counting?.floodlight_activity_configs?.map(item => item.floodlight_activity_id) || []
}

export const getLineItemPixels = (lineItem, pixels) => {
  const lineItemPixelIds = getLineItemPixelIds(lineItem)
  return pixels.filter(pixel => lineItemPixelIds.includes(String(pixel.id)))
}
